import React from "react";
import { NodeRendererFolder } from "./NodeRendererFolder";
import { NodeRendererFile } from "./NodeRendererFile";
import { NodeRendererNew } from "./NodeRendererNew";

export const NodeRenderer = ({
  isBranch,
  ...props
}) => {
  return  (
    <>
      {isBranch 
        ? <NodeRendererFolder {...props} />
        : props.element.metadata?.isNew 
          ? <NodeRendererNew {...props} />
          : <NodeRendererFile {...props} />
      }
    </>
  )  
}

